import { IconProps } from './';

const defaultSize = 80;

export const WifiIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size || defaultSize;
  return (
    <svg
      className={className}
      width={sizeToUse}
      height={sizeToUse}
      viewBox="0 0 80 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40 57.0002L0 17.0002C5.33333 11.5557 11.4444 7.41683 18.3333 4.5835C25.2222 1.75016 32.4444 0.333496 40 0.333496C47.6111 0.333496 54.8611 1.75016 61.75 4.5835C68.6389 7.41683 74.7222 11.5557 80 17.0002L40 57.0002ZM14.5 22.0002C18.1111 19.3891 22.0694 17.3474 26.375 15.8752C30.6806 14.4029 35.2222 13.6668 40 13.6668C44.7778 13.6668 49.3194 14.4029 53.625 15.8752C57.9306 17.3474 61.8889 19.3891 65.5 22.0002L70.3333 17.1668C66 13.8891 61.2639 11.3752 56.125 9.62516C50.9861 7.87516 45.6111 7.00016 40 7.00016C34.3889 7.00016 29.0139 7.87516 23.875 9.62516C18.7361 11.3752 14 13.8891 9.66667 17.1668L14.5 22.0002Z"
        fill="#008000"
      />
    </svg>
  );
};
